// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  worldId: __t.u64().name("world_id"),
  water: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  species: __t.string(),
  cm: __t.f32(),
  castAt: __t.timestamp().name("cast_at"),
  biteAt: __t.timestamp().name("bite_at"),
});
